<template>
    <div>
        <div class="loader">
            <div class="loader__figure"></div>
            <p class="loader__label">Emarketing</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Preloader'
    }
</script>

<style scoped>

</style>